import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReviewsIOPolarisComponent } from './components/reviews-io-polaris.component';
import { ReviewsIORatingComponent } from './components/reviews-io-rating.component';
import { ReviewsIOService } from './reviews-io.service';

@NgModule({
    imports: [CommonModule],
    declarations: [ReviewsIOPolarisComponent, ReviewsIORatingComponent],
    exports: [ReviewsIOPolarisComponent, ReviewsIORatingComponent],
    providers: [ReviewsIOService]
})
export class ReviewsIOModule {
    constructor(private reviewsIOService: ReviewsIOService) {
        this.reviewsIOService.load();
    }
}
